import React from 'react';
import { Container, Label } from './styles';

function Input({ name, value, type, label, status = false, change, onBlur }) {

  const handleChange = (e) => {
    let rawValue = e.target.value;
    const cleaned = rawValue.replace(/[^a-zA-Z0-9]/g, '');

    change(cleaned);
  };

  const formatDisplay = (val) => {
    if (!val) return '';

    const clean = val.replace(/[^a-zA-Z0-9]/g, '');

    if (/[a-zA-Z]/.test(clean) || clean.length > 11) {
      if (clean.length <= 2) return clean;
      if (clean.length <= 5) return `${clean.slice(0, 2)}.${clean.slice(2)}`;
      if (clean.length <= 8) return `${clean.slice(0, 2)}.${clean.slice(2, 5)}.${clean.slice(5)}`;
      if (clean.length <= 12) return `${clean.slice(0, 2)}.${clean.slice(2, 5)}.${clean.slice(5, 8)}/${clean.slice(8)}`;
      return `${clean.slice(0, 2)}.${clean.slice(2, 5)}.${clean.slice(5, 8)}/${clean.slice(8, 12)}-${clean.slice(12, 14)}`;
    } else {
      if (clean.length <= 3) return clean;
      if (clean.length <= 6) return `${clean.slice(0, 3)}.${clean.slice(3)}`;
      if (clean.length <= 9) return `${clean.slice(0, 3)}.${clean.slice(3, 6)}.${clean.slice(6)}`;
      return `${clean.slice(0, 3)}.${clean.slice(3, 6)}.${clean.slice(6, 9)}-${clean.slice(9, 11)}`;
    }
  };

  return (
    <Container status={status.status}>
      <Label status={status.status}>{label}</Label>
      <input
        name={name}
        type={type}
        value={formatDisplay(value)}
        onChange={handleChange}
        onBlur={onBlur}
      />
      <div className="feedback">{status.feedback}</div>
    </Container>
  );
}

export default Input;